(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus-react/assets/react/constants.js') >= 0) return;  svs.modules.push('/modules/spelpaus-react/assets/react/constants.js');
'use strict';

const ROUTE = {
  home: '/',
  svsSuspension: '/suspension'
};
const CALL_STATUS = {
  SUCCESS: 'success',
  ERROR: 'error',
  CANCEL: 'cancel'
};
const SUSPENSION_PRODUCT_ID = {
  ALL: 'all',
  VEGAS: 'vegas',
  QUICKGAMES: 'quickGames'
};
const SUSPENSION_PRODUCTS = [{
  id: 'all',
  name: 'Alla spel'
}, {
  id: 'vegas',
  name: 'Vegas'
}, {
  id: 'quickGames',
  name: 'Lotter och KenoXpress'
}];
const SUSPENSION_PERIOD = [{
  id: '3',
  month: 3,
  period: '3 månader'
}, {
  id: '6',
  month: 6,
  period: '6 månader'
}, {
  id: '12',
  month: 12,
  period: '1 år'
}, {
  id: '36',
  month: 36,
  period: '3 år'
}];
svs.spelpaus.constants = {
  ROUTE,
  CALL_STATUS,
  SUSPENSION_PRODUCT_ID,
  SUSPENSION_PRODUCTS,
  SUSPENSION_PERIOD
};

 })(window);